import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Call from '@mui/icons-material/Call';
import Email from '@mui/icons-material/Email';
// import LocationOn from '@mui/icons-material/LocationOn';
import { SvgIconProps } from '@mui/material/SvgIcon';
import { useLawyerContext } from '../../context/lawyer-info-context';

type Contacts = {
  icon: (props: SvgIconProps) => JSX.Element;
  data: string | undefined;
}[];

function Item({ children }: React.PropsWithChildren<unknown>): JSX.Element {
  return (
    <Box
      sx={{
        display: 'flex',
        p: 1,
      }}
    >
      {children}
    </Box>
  );
}

export default function Contacts(): JSX.Element {
  const { t } = useTranslation();

  const lawyerInfo = useLawyerContext();

  const contacts = useMemo(
    (): Contacts => [
      { icon: Call, data: lawyerInfo.phone1 },
      { icon: Call, data: lawyerInfo.phone2 },
      { icon: Email, data: lawyerInfo.email },
      // { icon: LocationOn, data: lawyerInfo.address },
    ],
    [lawyerInfo]
  );

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: {
          xs: 'column',
          sm: 'row',
        },
        alignContent: {
          xs: 'center',
          sm: 'initial',
        },
      }}
    >
      {contacts.map(({ icon: Icon, data }) => (
        <Box
          key={data}
          sx={{
            display: 'flex',
            alignItems: 'center',
            ':not(:last-child)': {
              marginRight: {
                xs: 0,
                sm: 3,
              },
            },
          }}
        >
          <Item>
            <Icon />
          </Item>
          <Item>
            <Typography variant="h6">{data && t(data)}</Typography>
          </Item>
        </Box>
      ))}
    </Box>
  );
}
